<template>
  <div class="log__wrapper">
    <h2>{{this.mode | capitalize}} Logs</h2>
    <el-button  @click="loadNow()">Load Logs</el-button>
    <div v-loading="currentlyLoading" class="log-lines">
      <div v-for="(line, index) in lines" class="log-line">
        <span class="log-line__number">{{index}} {{line.timestamp / 1000 | moment('HH:mm:ss.SSS')}}</span>{{line.message}}</div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  import config from '@/config'

  export default {
    props: ['buildId', 'mode', 'loadImmediately'],
    name: 'ba-build-log',
    data () {
      return {
        isLoaded: false,
        currentlyLoading: false,
        lines: [],
      }
    },
    mounted () {
      if (this.loadImmediately) {
        this.loadNow()
      }
    },
    methods: {
      async loadNow () {
        this.currentlyLoading = true
        try {
          let urlPart = `build`
          if (this.mode === 'desktop') {
            urlPart = 'desktop-' + urlPart
          } else if (this.mode === 'deployment') {
            urlPart = 'desktop-deployment'
          }
          let response = await axios.get(`${config.url}/${urlPart}/${this.buildId}/logs/`)
          this.lines.length = 0
          this.lines.push(...response.data.events)
        } finally {
          this.currentlyLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .log-lines {
    background-color: #263131;
    color: white;
  }

  .log-line {
    white-space: pre;
    font-family: monospace;
    text-align: left;
    margin: 0 auto;
  }

  .log-line__number {
    display: inline-block;
    width: 180px;
    user-select: none;
    border-right: 1px solid #6c757d;
    margin-right: 1em;
    color: #9ca9b2;
    text-align: center;
  }
</style>